import { useState } from "react";
import PropTypes from "prop-types";

import { CtaGrid, IconListModal } from "@lululemon/dsp-legacy-shared";
import { Card, Carousel } from "@lululemon/dsp-ecom-pattern-library";

import getAmenitiesIconTextList from "@lululemon/dsp-store-details/src/util/get-amenities-icon-text-list";
import { STORE_SPACES_SUMMARY } from "../../content/analytics-tags";

import styles from "./spaces-grid.module.scss";

const SpacesGrid = ({
  featuredAmenity,
  hasFeaturedAmenity,
  storeSlug,
  storeName,
  storeAmenities,
  spaces,
  slidesPerPage,
  hasOneLinkTranslation
}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const hasAmenities = storeAmenities.length > 0;
  const mappedAmenities =
    storeAmenities &&
    getAmenitiesIconTextList(
      storeAmenities,
      hasOneLinkTranslation,
      hasFeaturedAmenity,
      featuredAmenity
    );

  const carouselCards = spaces?.storeSpaces.map((space) => {
    const cardImg = space.images?.find((img) =>
      img.tags.find((tag) => tag === "hero")
    );

    if (cardImg === undefined) {
      return null;
    }

    const formattedSpaceName = space.name.replace(/ /g, "-").toLowerCase();
    const spaceUrl = `${storeSlug}/spaces/${formattedSpaceName}`;

    return (
      <Card
        classes={{
          container: styles.card,
          imageContainer: styles.cardImage
        }}
        key={`store-space-card-${space.id}`}
        heading={space.name}
        imageProps={{
          src: cardImg.url,
          alt: cardImg.accessibilityText
        }}
        subContent={space.shortDescription}
        ctaURL={spaceUrl}
        data-component-link={STORE_SPACES_SUMMARY}
      />
    );
  });

  return (
    <CtaGrid
      textContainerAlignCenter={!hasAmenities}
      rightPanelExtraColumn
      heading={spaces.heading}
      description={spaces.description}
      leftPanel={
        storeAmenities && (
          <IconListModal
            analyticsId={STORE_SPACES_SUMMARY}
            listItems={mappedAmenities}
            modalSubHeading={storeName}
            modalHeading={spaces.modal?.heading}
            openModalText={spaces.modal?.open}
            maxListItems={spaces.modal?.maxListItems}
          />
        )
      }
      rightPanel={
        <Carousel
          slidesPerPage={slidesPerPage}
          showArrows={spaces?.storeSpaces.length > 2}
          showPagination
          paginationLocation="bottom"
          slideIndex={slideIndex}
          onSlideIndexChange={(value) => setSlideIndex(value)}
          classes={{
            carousel: styles.carousel,
            leftArrow: styles.arrow,
            rightArrow: styles.arrow
          }}
        >
          {carouselCards}
        </Carousel>
      }
    />
  );
};

SpacesGrid.propTypes = {
  featuredAmenity: PropTypes.string,
  hasFeaturedAmenity: PropTypes.bool,
  storeSlug: PropTypes.string,
  storeName: PropTypes.string,
  storeAmenities: PropTypes.arrayOf(PropTypes.string),
  spaces: PropTypes.shape({
    storeSpaces: PropTypes.arrayOf(
      PropTypes.shape({
        images: PropTypes.arrayOf(
          PropTypes.shape({
            accessibilityText: PropTypes.string,
            displayOrder: PropTypes.number,
            id: PropTypes.string,
            tags: PropTypes.arrayOf(PropTypes.string),
            url: PropTypes.string
          })
        ),
        about: PropTypes.string,
        longDescription: PropTypes.string,
        shortDescription: PropTypes.string,
        name: PropTypes.string
      })
    ),
    description: PropTypes.string,
    heading: PropTypes.string,
    modal: PropTypes.shape()
  }),
  slidesPerPage: PropTypes.number,
  hasOneLinkTranslation: PropTypes.bool
};

SpacesGrid.defaultProps = {
  featuredAmenity: "",
  hasFeaturedAmenity: false,
  storeSlug: "",
  storeName: "",
  storeAmenities: [],
  spaces: [],
  slidesPerPage: 1.33, // mobile
  isExperientialStore: false,
  hasOneLinkTranslation: false
};

export default SpacesGrid;
